import {useContext} from "react";

import {ProjectContext} from "../../contexts/ProjectContext";
import {CompanyType} from "../../models/company";

import BuilderVeView from "./veBuilder";
import DeveloperVeListView from "./veDeveloperList";

/**
 * VE
 *
 *
 *
 * */
export default function VEHomePage() {
    const projectContext = useContext(ProjectContext);

    if(projectContext === null){
        return <div>error</div>
    } else if (projectContext.role === CompanyType.developer) {
        return <DeveloperVeListView/>
    } else if (projectContext.role === CompanyType.builder) {
        return <BuilderVeView/>
    }
    return (<div> err </div>)
}